// extracted by mini-css-extract-plugin
export default {"deleteButton":"DeleteIcon_deleteButton__GmVyK"};